import classes from './Home.module.css';
import React, { useContext, useEffect, useState } from 'react';
import Customer from './Customers';
import TabsComponent from '../../components/Tabs/Tabs';
import { LoaderContext } from '../../context/LoaderContext';
import { START_LOADER, STOP_LOADER } from '../../constants';
import CreateCustomer from './Add Customer';
import CreateUser from './AddUser';
import SupportNotes from './SupportNotes/SupportNotes';
import ExternalApis from './ExternalApi';
import { CustomerService } from '../../services/CustomerService';
import FCRAggrements from '../RevenueSplit/FcrAggrements';
import CreateFCRAggrement from '../RevenueSplit/FcrAggrements/CreateFCRAggrement';
import { regulationsServiceAdmin } from '../../services/regulationsService';
import Instances from './Instances/index';
import LicensesV2 from './CreateLicense/createLicense-v2';
import Inventory from './Inventory';
import Onboarding from './Onboarding/Onboarding';
// External library imports
import { useLocation, useHistory } from 'react-router-dom';
import Resources from '../Edge';
import { useQueryParamWithDefault } from '../../hooks';
import { NumberParam, ObjectParam, StringParam } from 'use-query-params';
import RevenueCalculator from './RevenueCalculator';

const Home = ({ cId }) => {
    const [dynamicTab, setDynamicTab] = useState({ status: false, type: null, data: null });
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });
    const [refresh, setRefresh] = useState('');
    const [customersData, setCustomersData] = useState([]);
    const [selectedTab, setSelectedTab] = useQueryParamWithDefault('tab', NumberParam, 0, cId);
    const [revenueSplitCreateEdit, setRevenueSplitCreateEdit] = useState({
        status: false,
        data: null,
    });
    const [regulations, setRegulations] = useState([]);

    const handleError = (err) => {
        console.log(err);
    };

    useEffect(() => {
        CustomerService.ReadAll({ isActive: true }, startLoader, handleFetchSucess, handleError, stopLoader);
    }, [refresh]);

    const handleFetchSucess = ({ data }) => {
        setCustomersData(data.data);
    };

    useEffect(() => {
        fetchRegulations();
    }, []);

    const fetchRegulations = () => {
        regulationsServiceAdmin.RealAll(startLoader, handleRegulationsSuccess, handleError, stopLoader);
    };

    const handleRegulationsSuccess = ({ data }) => {
        const rgs = [];
        data?.data?.forEach((reg) => {
            rgs.push(reg.name);
        });
        setRegulations(rgs);
    };

    useEffect(() => {
        if (![5, 6].includes(selectedTab))
            setDynamicTab({
                status: false,
                type: null,
                data: null,
            });

        if (selectedTab === 5 && revenueSplitCreateEdit.status) setRevenueSplitCreateEdit({ status: false, data: null });
    }, [selectedTab]);

    useEffect(() => {
        if (dynamicTab?.status) setSelectedTab(5);
    }, [dynamicTab?.status]);

    let tabs = [
        {
            name: 'Customers',
            component: (
                <>
                    <Customer setRefresh={setRefresh} customersData={customersData} setDynamicTab={setDynamicTab} />
                </>
            ),
        },
        {
            name: 'Support Notes',
            component: (
                <>
                    <SupportNotes customersData={customersData} />
                </>
            ),
        },
        {
            name: 'Inventory',
            component: (
                <>
                    <Inventory customersData={customersData} />
                </>
            ),
        },
        {
            name: 'Onboarding',
            component: (
                <>
                    <Onboarding />
                </>
            ),
        },
        {
            name: 'Revenue Potential Calculator',
            component: <RevenueCalculator />,
        },
        ...(dynamicTab?.status
            ? [
                  ...(dynamicTab.type === 'customer'
                      ? [
                            {
                                name: !dynamicTab?.data?._id ? 'Create Customer' : 'Edit Customer',
                                component: <CreateCustomer customerdata={dynamicTab?.data || {}} setRefresh={setRefresh} setSelectedTab={setSelectedTab} />,
                            },
                        ]
                      : []),
                  ...(dynamicTab.type === 'edge'
                      ? [
                            {
                                name: 'Edge',
                                component: <Resources customer={dynamicTab?.data || {}} />,
                            },
                        ]
                      : []),
                  ...(dynamicTab.type === 'license'
                      ? [
                            {
                                name: 'Licenses',
                                component: (
                                    <>
                                        <LicensesV2 customer={dynamicTab?.data || {}} />
                                    </>
                                ),
                            },
                        ]
                      : []),
                  ...(dynamicTab.type === 'revenueSplit'
                      ? [
                            {
                                name: 'Revenue Split',
                                component: (
                                    <>
                                        <FCRAggrements customer={dynamicTab?.data || {}} setSelectedTab={setSelectedTab} setRevenueSplitCreateEdit={setRevenueSplitCreateEdit} />
                                    </>
                                ),
                            },
                        ]
                      : []),
                  ...(revenueSplitCreateEdit.status
                      ? [
                            {
                                name: revenueSplitCreateEdit?.data?._id ? 'Edit Aggrement' : 'Create Aggrement',
                                component: (
                                    <>
                                        <CreateFCRAggrement
                                            regulations={regulations}
                                            editAggrement={revenueSplitCreateEdit?.data || {}}
                                            customerId={dynamicTab?.data?._id}
                                            biddingMarkets={dynamicTab?.data?.biddingMarkets}
                                        />
                                    </>
                                ),
                            },
                        ]
                      : []),
                  ...(dynamicTab.type === 'externalApi'
                      ? [
                            {
                                name: 'External Api',
                                component: (
                                    <>
                                        <ExternalApis customersData={customersData} customerId={dynamicTab?.data?._id} />
                                    </>
                                ),
                            },
                        ]
                      : []),
                  ...(dynamicTab.type === 'instance'
                      ? [
                            {
                                name: 'Instances',
                                component: (
                                    <>
                                        <Instances customer={dynamicTab?.data} />
                                    </>
                                ),
                            },
                        ]
                      : []),
              ]
            : []),
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                selectedIndex={selectedTab}
                tabs={tabs}
                onChangeTab={(e) => {
                    setSelectedTab(e);
                }}
                cId={cId}
            />
        </div>
    );
};

export default Home;
